import wixWindow from 'wix-window';
import wixData from 'wix-data';
import { getUserDetails } from 'public/wixUsers';

let allItemsIds = [];

$w.onReady(function () {
	// CHECK IF IT'S A USER

	getUserDetails().then(user => {
			console.log(user)

			$w("#inputGuid").value = user.guid

		})

		.catch((err) => {

		});

	//

	$w("#repeater1").onItemReady(($item, itemData, index) => {
		allItemsIds.push(itemData._id);

		$item("#containerButton").onMouseIn(() => {
			$item("#hoverContainer").show();
		});

		$item("#containerButton").onMouseOut(() => {
			$item("#hoverContainer").hide();
		});

		$item("#containerButton").onClick(() => {
			wixData.query('Showcase')
				.eq('_id', itemData._id)
				.find()
				.then(async (result) => {
					await openLightbox(result.items[0], index, $w("#repeater1").data.length);
				});
		});
	});
});

async function openLightbox(itemData, index, totalItems) {
	console.log(allItemsIds)
	await wixWindow.openLightbox('ShowroomLB', {
		"id": itemData._id,
		"title": itemData.title,
		"partner": itemData.partner,
		"about": itemData.about,
		"siteLink": itemData.siteLink,
		"agencyLink": itemData.agencyLink,
		"mainImage": itemData.mainImage,
		'currentItem': index,
		'totalItems': totalItems,
		'idsList': allItemsIds
	});
}